var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.02414 14.25C9.31972 14.2505 9.61248 14.1926 9.88561 14.0796C10.1587 13.9666 10.4068 13.8007 10.6156 13.5915L13.5549 10.65L12.4944 9.5925L9.76964 12.318L9.75014 0H8.25014L8.26964 12.306L5.55464 9.591L4.49414 10.65L7.43339 13.5892C7.64195 13.7987 7.88985 13.9649 8.16284 14.0783C8.43583 14.1917 8.72854 14.2501 9.02414 14.25Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5 12V15.75C16.5 15.9489 16.421 16.1397 16.2803 16.2803C16.1397 16.421 15.9489 16.5 15.75 16.5H2.25C2.05109 16.5 1.86032 16.421 1.71967 16.2803C1.57902 16.1397 1.5 15.9489 1.5 15.75V12H0V15.75C0 16.3467 0.237053 16.919 0.65901 17.341C1.08097 17.7629 1.65326 18 2.25 18H15.75C16.3467 18 16.919 17.7629 17.341 17.341C17.7629 16.919 18 16.3467 18 15.75V12H16.5Z",
    fill: "#374957"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadExcelIcon);
export default __webpack_public_path__ + "static/media/downloadExcelIcon.540f4d969cc6f72379c773462fb07b5e.svg";
export { ForwardRef as ReactComponent };